export const getInitialsFromName = (fullName: string) => {
  const words = fullName
    .split(' ')
    .map((word) => word.trim())
    .filter((word) => word.length > 0);

  const initials = words.map((word) => word.charAt(0).toUpperCase()).join('');

  return initials;
};
